import React from 'react';
import { useAuth } from '../../../features/auth';
import { MainSidebar, useSidebar } from '../../../widgets/main-sidebar';
import { Topbar } from '../../../widgets/topbar';
import { IntScorozvonSection } from './sections/IntScorozvonSection';

const IntScorozvonPage: React.FC = () => {
  const { currentUser, logout } = useAuth();
  const { toggle } = useSidebar();

  if (!currentUser) return null;

  return (
    <div id="app-screen">
      <Topbar user={currentUser} onLogout={logout} onSidebarToggle={toggle} />
      <div className="app-body">
        <MainSidebar isAdmin={currentUser.role === 'ADMIN'} isManager={currentUser.role === 'MANAGER'} />
        <div className="app-content adm-content">
          <IntScorozvonSection />
        </div>
      </div>
    </div>
  );
};

export { IntScorozvonPage };
